import React from "react";
import styled from "styled-components";
import BaseCard from "./BaseCard";

const Card = styled(BaseCard)`
  align-items: center;
  justify-content: center;
`;

const ReadAllLink = styled.a`
  color: #5b9bd5;
  text-decoration: none;
  font-size: 1.1em;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

const CarouselReadAllCard = ({ truncateDest }) => {
  return (
    <Card className="fdn-carousel-read-all">
      <ReadAllLink href={truncateDest}>
        Read All Reviews &rarr;
      </ReadAllLink>
    </Card>
  );
};

export default CarouselReadAllCard;



// WEBPACK FOOTER //
// ./src/components/carousel/CarouselReadAllCard.jsx